import * as React from "react";
import { createRoot } from "react-dom/client";

import App from "./components/App";
import { ThemedRoot } from "../components/ThemedRoot";

/* global document, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/*
 * Rendered immediately, not inside Office.onReady.
 *
 * Office.onReady never resolves outside an Office host, so gating the render
 * on it would make https://localhost:3000/taskpane.html a permanently blank
 * page — and that page is how the sign-in and ticket flow get tested without
 * Outlook in the loop. Anything that genuinely needs Office (reading the open
 * message) waits for it where it is used.
 */
root?.render(
  <ThemedRoot>
    <App />
  </ThemedRoot>
);

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(
      <ThemedRoot>
        <NextApp />
      </ThemedRoot>
    );
  });
}
